import { render, staticRenderFns } from "./ReportsSection.vue?vue&type=template&id=8124e394&scoped=true&"
import script from "./js/reports-section.js?vue&type=script&lang=js&"
export * from "./js/reports-section.js?vue&type=script&lang=js&"
import style0 from "./ReportsSection.vue?vue&type=style&index=0&id=8124e394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8124e394",
  null
  
)

export default component.exports